import React from 'react';
import '../../css/Sample.css';

function SampleTemplate(props) {
  const { playerName, playerVersion, playerContainerId, playerPreloader } = props;
  return (
    <div className="sample_page">
      <div className="sample_page_container">
        <div className="sample_header">
          {'Sample of integration ' +
            playerName +
            ' ' +
            (playerVersion !== '0' ? playerVersion : '') +
            ' with Smart Video Instream Plugin'}
        </div>
        <div className={playerPreloader ? 'sample_preloader_on' : 'sample_preloader_off'}></div>
        <table>
          <tbody>
            <tr>
              <td valign="top" className="player_column">
                <div id="articleContent">
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div id={playerContainerId}></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <br />
                  <div className="bloc1"></div>
                  <br />
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                  <div className="bloc8"></div>
                </div>
              </td>
              <td valign="top">
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc6" id="companionDiv1"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc7"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div id="col1_bloc3"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc6"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
                <div className="bloc7"></div>
                <div className="bloc8"></div>
                <div className="bloc8"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SampleTemplate;
